import { RootState } from "@/types/store";
import { get, set } from "@/utils/vuex";
import Vue from "vue";
import Vuex, { ActionContext } from "vuex";
import auth from "@/store/modules/auth";
import snackbar from "@/store/modules/snackbar";
import billingPortal from "@/store/modules/billingPortal";
import customer from "@/store/modules/customer";
import paymentIntent from "@/store/modules/paymentIntent";
import paymentMethod from "@/store/modules/paymentMethod";
import checkout from "@/store/modules/checkout";

Vue.use(Vuex);

export default new Vuex.Store({
  state: (): RootState => ({
    logoSrc: "",
  }),
  mutations: {
    setLogoSrc: set("logoSrc"),
  },
  getters: {
    getLogoSrc: get("logoSrc"),
  },
  actions: {
    loadLogo(context: ActionContext<RootState, RootState>) {
      if (context.getters.getLogoSrc) {
        return;
      }

      let logoImg;

      try {
        logoImg = require(`../configs/${process.env.VUE_APP_CONFIG}/assets/logo.png`);
      } catch (e) {
        //console.log(e);
      }

      if (!logoImg) {
        try {
          logoImg = require(`../configs/${process.env.VUE_APP_CONFIG}/assets/logo.svg`);
        } catch (e) {
          //console.log(e);
        }
      }

      context.commit("setLogoSrc", logoImg);
    },
  },
  modules: {
    auth,
    snackbar,
    billingPortal,
    customer,
    paymentIntent,
    paymentMethod,
    checkout,
  },
});
